import { useQuery, useMutation } from 'react-query';

import { useCurrentUserId, toastError, queryClient, request } from '@/utils';
import { OAuthClientInfo } from '@/views/Connect/types';

type AuthorizedDappsRes = {
  apps: OAuthClientInfo[];
};

export function useAuthorizedDapps() {
  const userId = useCurrentUserId();
  const url = '/oauth/authorized';

  const query = useQuery([url, userId], () => request.get<AuthorizedDappsRes>(url), {
    select: res => res?.apps,
  });

  return query;
}

export function useDappAuthRevoke(app_id: string) {
  return useMutation(
    () => {
      return request.post<{ is_success: boolean }>('/oauth/revoke', {
        app_id,
      });
    },
    {
      onSuccess({ is_success }) {
        if (is_success) {
          queryClient.setQueriesData<AuthorizedDappsRes | undefined>(['/oauth/authorized'], pre => {
            if (!pre) {
              return pre;
            }

            return { apps: pre?.apps?.filter(x => x.id !== app_id) };
          });
        }
      },
      onError(e) {
        toastError(e || 'Failed to subscribe');
      },
    },
  );
}
